import { Component } from "react";
import BaseModal, { ModalActions, SaveButton, CancelButton } from "../../../../containers/UI/Modal/BaseModal";
import InputRow from "../../../configuration/Rows/InputRow/InputRow";
import SelectRow from "../../../configuration/Rows/SelectRow/SelectRow";
import axios from "../../../../axios";
import classes from "./CompanyModal.css";

class CompanyModal extends Component {

  state = {
    loading: true,
    companyDetails: null,
    selectedOwnerId: null
  }

  componentDidMount() {
    this.loadCompanyDetails();
  }

  loadCompanyDetails = () => {
    const { selectedCompany } = this.props;
    if (!selectedCompany) return;

    this.setState({ loading: true });

    axios.get(`/platforms/companies/${selectedCompany._id}`)
      .then(response => {
        if (response.data && response.data.company) {
          this.setState({
            companyDetails: response.data.company,
            selectedOwnerId: response.data.company.owner ? response.data.company.owner._id : null,
            loading: false
          });
        }
      })
      .catch(err => {
        console.error("Failed to load company details:", err);
        this.setState({ loading: false });
      });
  }

  changeOwnerHandler = () => {
    const { selectedOwnerId, companyDetails } = this.state;

    if (!selectedOwnerId) {
      alert("Please select a new owner.");
      return;
    }

    if (companyDetails.owner && selectedOwnerId === companyDetails.owner._id) {
      alert("This member is already the owner.");
      return;
    }

    if (!window.confirm("Are you sure you want to change the company owner?")) {
      return;
    }

    this.setState({ loading: true });

    axios.post(`/platforms/companies/${companyDetails._id}/change-owner`, {
      newOwnerId: selectedOwnerId
    })
      .then(() => {
        alert("Company owner has been updated successfully.");
        this.props.closeModal();
      })
      .catch(err => {
        let message = "Failed to change company owner.";
        if (err.response && err.response.data && err.response.data.message) {
          message = err.response.data.message;
        }
        alert(message);
        this.setState({ loading: false });
      });
  }

  render() {
    const { companyDetails, loading, selectedOwnerId } = this.state;

    if (loading || !companyDetails) {
      return (
        <BaseModal
          isOpen={this.props.shouldShow}
          onClose={this.props.closeModal}
          title="Company Details"
        >
          <div style={{ padding: "20px", textAlign: "center" }}>Loading...</div>
        </BaseModal>
      );
    }

    return (
      <BaseModal
        isOpen={this.props.shouldShow}
        onClose={this.props.closeModal}
        title="Company Details"
      >
        <InputRow
          title="Company Name"
          firstRow
          ultrawide
          value={companyDetails.companyName || ""}
          placeholder="—"
        />
        <InputRow
          title="VAT Number"
          ultrawide
          value={companyDetails.vatNumber || ""}
          placeholder="—"
        />
        <InputRow
          title="Organization Number"
          ultrawide
          value={companyDetails.orgAccountNumber || ""}
          placeholder="—"
        />
        <InputRow
          title="Country"
          ultrawide
          value={companyDetails.billingAddress?.country || ""}
          placeholder="—"
        />
        <InputRow
          title="Peppol ID"
          ultrawide
          value={companyDetails.peppolId || ""}
          placeholder="—"
        />

        <div className={classes.section}>
          <h3>Billing Address</h3>
          <InputRow
            title="Address Line 1"
            ultrawide
            value={companyDetails.billingAddress.line1 || ""}
            placeholder="—"
          />
          <InputRow
            title="Address Line 2"
            ultrawide
            value={companyDetails.billingAddress.line2 || ""}
            placeholder="—"
          />
          <InputRow
            title="Country"
            ultrawide
            value={companyDetails.billingAddress.country || ""}
            placeholder="—"
          />
        </div>

        <div className={classes.section}>
          <h3>Delivery Address</h3>
          <InputRow
            title="Address Line 1"
            ultrawide
            value={companyDetails.deliveryAddress.line1 || ""}
            placeholder="—"
          />
          <InputRow
            title="Address Line 2"
            ultrawide
            value={companyDetails.deliveryAddress.line2 || ""}
            placeholder="—"
          />
          <InputRow
            title="Country"
            ultrawide
            value={companyDetails.deliveryAddress.country || ""}
            placeholder="—"
          />
        </div>

        <div className={classes.section}>
          <h3>Members ({companyDetails.memberCount})</h3>


          <div className={classes.membersList}>
            {companyDetails.members.map(member => (
              <div key={member._id} className={classes.memberItem}>
                <div className={classes.memberName}>
                  {member.name}
                  {companyDetails.owner && member._id === companyDetails.owner._id && (
                    <span className={classes.ownerBadge}>Owner</span>
                  )}
                </div>
                <div className={classes.memberEmail}>{member.email}</div>
                <div className={classes.memberDetails}>
                  Account: {member.accountNumber}
                </div>
              </div>
            ))}
          </div>
        </div>

        <SelectRow
          title="Company Owner"
          firstRow
          ultrawide
          value={selectedOwnerId || ""}
          onChange={(newValue) => this.setState({ selectedOwnerId: newValue ? newValue.value : null })}
          options={companyDetails.members.map(member => ({
            label: `${member.name} (${member.email})`,
            value: member._id
          }))}
        />

        <ModalActions>
          <CancelButton onClick={this.props.closeModal}>Close</CancelButton>
          <SaveButton onClick={this.changeOwnerHandler} disabled={loading}>
            Change Owner
          </SaveButton>
        </ModalActions>
      </BaseModal>
    );
  }
}

export default CompanyModal;
